import type { CSSProperties } from "react";
import "./board.css";

const PIPS: Record<number, number[]> = {
  1: [5],
  2: [1, 9],
  3: [1, 5, 9],
  4: [1, 3, 7, 9],
  5: [1, 3, 5, 7, 9],
  6: [1, 3, 4, 6, 7, 9],
};

function Face({ n }: { n: number }) {
  const on = new Set(PIPS[n]);
  return (
    <div className={`gb-face gb-face-${n}`} aria-hidden="true">
      {Array.from({ length: 9 }, (_, i) => (
        <span key={i} className={on.has(i + 1) ? (n === 1 ? "gb-pip gb-pip-one" : "gb-pip") : "gb-pip-empty"} />
      ))}
    </div>
  );
}

function Die({ value, rolling, rollId, dir }: { value: number; rolling: boolean; rollId: number; dir: 1 | -1 }) {
  return (
    <div className="gb-die">
      <div className="gb-die-tilt">
        <div key={rollId} className={rolling ? "gb-die-spin gb-die-rolling" : "gb-die-spin"} style={{ "--dir": dir } as CSSProperties}>
          <div className={`gb-die-cube gb-show-${value}`}>
            {[1, 2, 3, 4, 5, 6].map((n) => (
              <Face key={n} n={n} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export interface DiceViewProps {
  /** The two dice, null before the first roll of the game. */
  dice: [number, number] | null;
  /** Plays the tumble animation. */
  rolling?: boolean;
  /** Edge length of one die: pixels, or any CSS length such as "8cqw". */
  size?: number | string;
  /** Change it to replay the tumble for a new roll while `rolling` stays true. */
  rollId?: number;
}

/** Two 3D dice. Purely visual: the result comes from the server. */
export function DiceView({ dice, rolling = false, size = 44, rollId = 0 }: DiceViewProps) {
  const label = dice
    ? `Würfel: ${dice[0]} und ${dice[1]}, Summe ${dice[0] + dice[1]}`
    : "Würfel: noch nicht geworfen";
  const style = { "--die": typeof size === "number" ? `${size}px` : size } as CSSProperties;
  const values = dice ?? [1, 1];
  return (
    <div className={dice ? "gb-dice" : "gb-dice gb-dice-idle"} role="img" aria-label={label} style={style}>
      <Die value={values[0]} rolling={rolling} rollId={rollId} dir={1} />
      <Die value={values[1]} rolling={rolling} rollId={rollId} dir={-1} />
    </div>
  );
}
